import React, { useState, useEffect } from 'react'
import "./forgetPassword.css"
import Card from 'react-bootstrap/Card';
import axios from 'axios';
import { API_URL } from "../../services/config/endpoints"
import { AiFillMail } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri"
import { IconContext } from "react-icons"
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import { useParams } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
export default function Forgetpassword() {
  let { id, token } = useParams();
  // console.log('welcom to  board', id, token);
  let navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false)
  const [ErrorMsg, setErrorMsg] = useState("")
  // console.log('error',ErrorMsg)
  const handleCheckVarify = () => {

    axios.get(`${API_URL}api/reset-password/${id}/${token}`)
      .then((res) => {
        console.log('res handle check :', res)
      }).catch((err) => {
        console.log('err handle check', err)
        setErrorMsg(err.response?.data?.msg)
      })
  }
  useEffect(() => {
    handleCheckVarify()
  }, [])
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",


    },
    onSubmit: values => {
      setLoader(true)
      axios.put(`${API_URL}api/forgetPassword`, values)
        .then(res => console.log("values formik: ", res));
      toast.success('Password Reset Successfully', {
        theme: 'colored'
      })
      navigate("/landing")
      setLoader(false)
        .catch(err => console.log("values formik: ", err))

    },
    validate: values => {

      let errors = {}
      if (!values.email) {
        errors.email = 'Email Required'
      } else if (!/^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid Email Format'
      }
      if (!values.password) {
        errors.password = 'New Password Required'

      }

      if (!values.confirmPassword) {
        errors.confirmPassword = 'Confirm Password Required'

      }
      if (values.password !== values.confirmPassword) {
        errors.confirmPassword = 'Passwords do not match'
      }

      return errors

    }

  })
  const showPasswordHandler = () => {
    setShowPassword(!showPassword)
  }
  return (
    <div className="container-forget">
      <div className="img-profile">
      </div>
      {ErrorMsg ?
        <div className='cr'>
           <Card style={{ width: '18rem' }}>
      <Card.Body >
        <Card.Title className='tr'>Link Expired</Card.Title>
      </Card.Body>
    </Card>
        </div> :
        <div className='sigin-form'>
          <form onSubmit={formik.handleSubmit}>
            <h1 className="register-heading">Forget Password</h1>
            <div className="input-main mt-4">
              <div>
                <IconContext.Provider value={{ size: '16px' }}
                >  <span className="E"><AiFillMail /></span></IconContext.Provider>

                <input className="input-box" type="email" id='email' placeholder="Enter Email"
                  value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? <div className='error'>{formik.errors.email}</div> : null}
              </div>
              <div>
                <span className="P"><RiLockPasswordFill /></span>

                <input className="input-box" type={showPassword ? "text" : "password"} id='password' placeholder="New Password"
                  value={formik.values.password} onChange={formik.handleChange} onBlur={formik.handleBlur}
                />
                {formik.touched.password && formik.errors.password ? <div className='error'>{formik.errors.password}</div> : null}
              </div>
              <div>
                <span className="P"><RiLockPasswordFill /></span>
                <input className="input-box" type={showPassword ? "tesxt" : "password"} id='confirmPassword' placeholder="Confirm password"
                  value={formik.values.confirmPassword} onChange={formik.handleChange} onBlur={formik.handleBlur}
                />
                {formik.touched.confirmPassword && formik.errors.confirmPassword ? <div className='error'>{formik.errors.confirmPassword}</div> : null}
              </div>
              <div className="show-password mt-3">
                <input
                  type="checkbox"
                  name="showPassword"
                  id="showPassword"
                  onClick={showPasswordHandler}
                />
                &nbsp;
                <label htmlFor="showPassword">Show Password</label>
              </div>
            </div>
            <div className="subminte-btn-main">
              <button disabled={loader} className='submite-btn' type="submit">Reset-Password</button>


            </div>


          </form>


        </div>

      }
    </div>

  )
}
